export const getStyled = (theme) => ({
  title: {
    color: theme.palette.mode === 'dark' ? '#FFF ' : theme.palette.primary.main,
  },
});
